import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import * as React from 'react';

type Props = {
    isDisabled: boolean;
    isDynamicList: boolean;
    onOpenDialogHandler: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function ButtonSaveFilters({
    isDisabled,
    isDynamicList,
    onOpenDialogHandler,
}: Props) {
    const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);

    const anchorRef = React.useRef<HTMLDivElement | null>(null);

    const handleOpenMenu = () => {
        setIsMenuOpen(true);
    };

    const handleCloseMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <React.Fragment>
            {!isDynamicList ? (
                /*
                        current conversation grid list is not dynamic; only option is to
                        create a new list from set filters
                     */
                <Button
                    variant="outlined"
                    color="secondary"
                    data-dialog-id="create_filter_group"
                    onClick={onOpenDialogHandler}
                    disabled={isDisabled}
                >
                    Apply &amp; Save
                </Button>
            ) : (
                /*
                        current conversation grid list is dynamic; provide options for overwriting
                        list's filters or creating a new list from set filters
                    */
                <React.Fragment>
                    <ButtonGroup
                        size="small"
                        variant="outlined"
                        color="primary"
                        disabled={isDisabled}
                        ref={anchorRef}
                    >
                        <Button data-dialog-id="update_filter_group" onClick={onOpenDialogHandler}>
                            Save
                        </Button>
                        <Button color="secondary" size="small" onClick={handleOpenMenu}>
                            <ArrowDropDownIcon />
                        </Button>
                    </ButtonGroup>
                    <Popper
                        open={isMenuOpen}
                        anchorEl={anchorRef.current}
                        transition
                        disablePortal
                        style={{ zIndex: 150 }}
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin:
                                        placement === 'bottom' ? 'center top' : 'right bottom',
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener onClickAway={handleCloseMenu}>
                                        <MenuList>
                                            <MenuItem
                                                data-dialog-id="create_filter_group"
                                                onClick={onOpenDialogHandler}
                                            >
                                                Save As
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}
